// custom typefaces

import "fontsource-montserrat/200.css"
import "fontsource-montserrat/300.css"
import "fontsource-montserrat/400.css"
import "fontsource-montserrat/700.css"

import "fontsource-merriweather/400.css"


// normalize CSS across browsers
import "./src/normalize.css"
// custom CSS styles
import "./src/style.css"

// Highlighting for code blocks
import "prismjs/themes/prism.css"
